/// src/components/uni/ProjectModuleWeb.js
import React, { useState, useContext } from 'react';
import { LanguageContext } from '../translations/LanguageContext';
import './ProjectModuleWeb.css';
import Footer from '../components/Footer'; // Reuse your existing Footer component

function ProjectModuleWeb() {
  const { language, translations } = useContext(LanguageContext);
  const t = translations[language].projectModuleWebPage;
  // State to handle which tab is active
  const [activeTab, setActiveTab] = useState('summary');

  return (
    <div className="projectmoduleweb-page">
      {/* Hero Section */}
      <header
        className="pmw-hero"
        style={{
          backgroundImage: `url("${t.hero.backgroundImage}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="pmw-hero-content">
          <h1>{t.hero.title}</h1>
          <h2>{t.hero.subtitle}</h2>
          <p className="pmw-hero-subtitle">{t.hero.tech}</p>
        </div>
        <img
          src={t.hero.heroImage}
          alt={t.hero.figureAlt}
          className="pmw-hero-figure"
        />
      </header>

      {/* Tabs Section */}
      <nav className="pmw-tabs">
        <button
          className={activeTab === 'summary' ? 'active' : ''}
          onClick={() => setActiveTab('summary')}
        >
          {t.tabs.summary}
        </button>
        <button
          className={activeTab === 'concept' ? 'active' : ''}
          onClick={() => setActiveTab('concept')}
        >
          {t.tabs.concept}
        </button>
        <button
          className={activeTab === 'challenges' ? 'active' : ''}
          onClick={() => setActiveTab('challenges')}
        >
          {t.tabs.challenges}
        </button>
      </nav>

      {/* Main Content Section */}
      <section className="pmw-content-section">
        <div className="pmw-content-wrapper">
          <div className="pmw-content-text">
            {activeTab === 'summary' &&
              t.summaryText.map((paragraph, i) => <p key={i}>{paragraph}</p>)}
            {activeTab === 'concept' &&
              t.conceptText.map((paragraph, i) => <p key={i}>{paragraph}</p>)}
            {activeTab === 'challenges' &&
              t.challengesText.map((paragraph, i) => <p key={i}>{paragraph}</p>)}
          </div>
          {/* Display the corresponding image */}
          <div className="pmw-content-image">
            <img
              src={t.tabImages[activeTab]}
              alt={`${activeTab} illustration`}
              className="pmw-tab-image"
            />
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="pmw-process-section">
        <h2 className="pmw-process-title">{t.process.title}</h2>
        {t.process.phases.map((phase, idx) => (
          <div key={idx} className="pmw-phase-row">
            <div className="pmw-phase-text">
              <h3>{phase.title}</h3>
              <p>{phase.content}</p>
            </div>
            <div className="pmw-phase-placeholder">
              <iframe
                src={`${phase.pdf}#toolbar=0&navpanes=0&scrollbar=0&zoom=page-fit`}
                title={`${phase.title} PDF`}
                className="pmw-phase-iframe"
              />
            </div>
          </div>
        ))}
      </section>

      <Footer />
    </div>
  );
}

export default ProjectModuleWeb;
